import { Navigate, Outlet, useParams } from "react-router";
import { useTenantApartments } from "@/api/tenant/queries";
import { isValidLang, ROUTE_SLUGS } from "@/config/routes";
import { useAuth } from "@/contexts/auth-context";
import { getUserRole } from "@/types/auth";

export function TenantClaimGuard() {
	const { user } = useAuth();
	const { lang } = useParams<{ lang: string }>();
	const currentLang = lang && isValidLang(lang) ? lang : "pl";
	const role = user ? getUserRole(user) : null;
	const isEndUser = role === "end_user";
	const { data, isPending } = useTenantApartments({
		enabled: isEndUser,
	});

	if (!isEndUser) {
		return <Outlet />;
	}

	if (isPending) {
		return null;
	}

	if (!data || data.length === 0) {
		return (
			<Navigate
				to={`/${currentLang}/${ROUTE_SLUGS.activateApartment[currentLang]}`}
				replace
			/>
		);
	}

	return <Outlet />;
}
